<nav #navbarCommon class="navbar navbar-expand-lg navbar-light fixed-top" [style]="{background: this.bgColor}">
  <div class="container">
    <a class="navbar-brand text-center p-0" href="#">
      <img [src]="'assets/logos/logo2.png'" [ngStyle]="{ width: namespace === 'onex-usa' ? '60px' : '120px' }" height="100%" class="d-inline-block align-top" alt="">
      <p class="m-0 p-0 bottom-center text-primary text-center smallHomeUrl">{{ url }}</p>
    </a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span *ngIf="!this.navbarWhiteIcon" class="navbar-toggler-icon"></span>
      <span *ngIf="this.navbarWhiteIcon"><i class="fas fa-bars text-white"></i></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto align-middle">
        <li class="nav-item mb-1">
          <a class="nav-link btn-large-navbar home"
            [style]="{color: this.textColor ? this.textColor : ''}" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
            (click)="navigationScrollin($event, '/')">
            {{ "shared.nav.home" | translate: {Default: "Inicio"} }}
          </a>
        </li>
        <li class="nav-item mb-1">
          <a class="nav-link btn-large-navbar aboutUs"
            [style]="{color: this.textColor ? this.textColor : ''}" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
            (click)="navigationScrollin($event, '/aboutUs')">
            {{ "shared.nav.us" | translate: {Default: "Quiénes somos"} }}
          </a>
        </li>
        <li class="nav-item mb-1">
          <a class="btn btn-primary btn-large-navbar text-white balanceCheck" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" pageScroll [routerLink]="['/login']" [pageScrollOffset]="0" [pageScrollDuration]="300" [pageScrollInterruptible]="false" href="#top_main" (click)="navChangeLink($event)">{{ "shared.nav.login" | translate: {Default: "Ingresa a tu cuenta"} }}</a>
        </li>
        <li class="nav-item mb-1">
          <a class="nav-link btn-large-navbar contactUs_q"
            [style]="{color: this.textColor ? this.textColor : ''}" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
            (click)="scrollToContact($event)">
            {{ "shared.nav.contact_us" | translate: {Default: "Contáctanos"} }}
          </a>
        </li>
        <li *ngIf="configurationService.application.onboardingEnable" class="nav-item mb-1">
          <a class="btn btn-primary btn-large-navbar text-white cardRequest mr-2" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" pageScroll [routerLink]="['/onboarding']" [pageScrollOffset]="0" [pageScrollDuration]="300" [pageScrollInterruptible]="false" href="#top_main" (click)="navChangeLink($event)">{{ "shared.nav.get_account" | translate: {Default: "Obtén tu cuenta"} }}</a>
        </li>
        <li class="nav-item mb-1">
          <a class="nav-link btn-large-navbar"
            [style]="{color: this.textColor ? this.textColor : ''}" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"
            (click)="navigationScrollin($event, '/faq')">
            {{ "shared.nav.faqs" | translate: {Default: "Preguntas frecuentes"} }}
          </a>
        </li>
        <li class="nav-item mb-1">
          <a class="btn btn-primary btn-large-navbar text-white" [style]="{background: this.reloadCardBg ? this.reloadCardBg : ''}" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" href="javascript:void(0);" (click)="scrollToComponent()">{{ "shared.nav.load_card" | translate: {Default: "Deposita efectivo"} }}</a>
        </li>
      </ul>
      <div class="text-center justify-content-center">
        <a class="d-inline-block nav-item nav-link" [style]="{color: this.textColor ? this.textColor : ''}">
          <img src="assets/flags/es.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('es')" alt="">
        </a>
        <a class="d-inline-block nav-item nav-link" [style]="{color: this.textColor ? this.textColor : ''}">
          <img src="assets/flags/en.png" height="20" class="d-inline-block align-top" (click)="changeLanguage('en')" alt="">
        </a>
      </div>
    </div>
  </div>
</nav>

<ngx-toasta [position]="'top-center'"></ngx-toasta>

<main class="main">
  <!--DELETE [style]="{'padding-top':navbarCommon.offsetHeight+'px'}"-->
  <div class="main-padding">
    <router-outlet></router-outlet>
  </div>
</main>

<app-footer></app-footer>

<ng-template #modal_greenDot let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ "shared.nav.directed_new_website" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ "shared.nav.privacy_policy" | translate}}</p>
  </div>
  <div class="modal-footer">
    <div class="btn-group">
      <button type="button" class="btn btn-outline-dark" (click)="modal.close()">{{ "shared.nav.cancel" | translate}}</button>
      <a class="btn btn-primary" href="https://secure.attheregister.com/locations" target="_blank">{{ "shared.nav.accept" | translate}}</a>
    </div>
  </div>
</ng-template>
